import api from "./axios";

/**
 * Get analytics data for a specific platform from HypeAuditor
 * @param {string} platform - Platform name (instagram, tiktok, youtube, facebook)
 * @param {string} username - Optional username/handle for the platform
 * @returns {Promise} Analytics data
 */
export const getPlatformAnalytics = async (platform, username = null) => {
  const params = username ? { username } : {};
  const response = await api.get(`/analytics/${platform}`, { params });
  return response.data;
};

/**
 * Get real analytics for a mint space (views, earnings/spent, submissions, active campaigns)
 * @param {string} mintSpaceId
 * @returns {Promise} Analytics data
 */
export const getMintSpaceAnalytics = async (mintSpaceId) => {
  const response = await api.get(`/analytics/mintspace/${mintSpaceId}`);
  return response.data;
};






